'use strict';

var exporter = require('ipfs-unixfs-engine').exporter;

var pull = require('pull-stream/pull');

var once = require('pull-stream/sources/once');

var asyncMap = require('pull-stream/throughs/async-map');

var defer = require('pull-defer');

var collect = require('pull-stream/sinks/collect');

var UnixFs = require('ipfs-unixfs');

var _require = require('./utils'),
    traverseTo = _require.traverseTo,
    createLock = _require.createLock;

var log = require('debug')('ipfs:mfs:read-pull-stream');

var defaultOptions = {
  offset: 0,
  length: undefined
};

module.exports = function (ipfs) {
  return function mfsReadPullStream(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options = Object.assign({}, defaultOptions, options);
    log("Reading ".concat(path));
    var deferred = defer.source();
    pull(once(path), asyncMap(function (path, cb) {
      createLock().readLock(function (next) {
        traverseTo(ipfs, path, {
          parents: false
        }, next);
      })(cb);
    }), asyncMap(function (result, cb) {
      var node = result.node;
      var meta = UnixFs.unmarshal(node.data);

      if (meta.type !== 'file') {
        return cb(new Error("".concat(path, " was not a file")));
      }

      log("Getting ".concat(path, " content"));
      pull(exporter(node.multihash, ipfs.dag, {
        offset: options.offset,
        length: options.length
      }), collect(function (error, files) {
        cb(error, error ? null : files[0].content);
      }));
    }), collect(function (error, streams) {
      if (error) {
        return deferred.abort(error);
      }

      if (!streams.length) {
        return deferred.abort(new Error("Could not load content stream from ".concat(path)));
      }

      log("Got ".concat(path, " content"));
      deferred.resolve(streams[0]);
    }));
    return deferred;
  };
};